module.exports = __webpack_public_path__ + "static/media/ball_4_3.0c9104cf.mp3";